import React from "react";

import { NavigationContext } from "../context/navigation_tabs_provider";

const useTabsNavigation = () => React.useContext(NavigationContext);

export default useTabsNavigation;